import styles from "./customCell.module.css";

const CustomCell = ({ cell }) => {
  const renderCellContent = () => {
    if (cell.column.editable) {
      if (cell.value) {
        return cell.render("Cell");
      } else if (cell.column.id === "statusName") {
        return "Выберите";
      } else {
        return "Введите";
      }
    } else {
      return cell.render("Cell");
    }
  };

  const getCellClassName = () => {
    return !cell.value && cell.column.editable ? styles["cell-custom"] : "";
  };

  return <div className={getCellClassName()}>{renderCellContent()}</div>;
};

export default CustomCell;
